import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { InputAdornment, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import jwt_decode from "jwt-decode";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  REACT_DASHBOARD_PANEL,
  REACT_URL_DASHBOARD,
} from "../../actions/EndPoints";
import keyIcon from "../../assets/LoginKeyAuthenticate.svg";
import Toast from "../../components/ToastContainer/CustomToast";
import CommonUtil from "../../components/Util/CommonUtils";
import { getListSettingsById } from "../../slices/AdditionalSettings/AdditionalSettingsSlice";
import {
  generateAuthenticationOTPResend,
  validateAuthenticationCode,
} from "../../slices/LoginAuthentication/LoginAuthenticationSlice";
import GlobalDataContext from "../GlobalDataContext";
import LoginLayoutV2 from "../OnBoardV2/LoginLayoutV2";

const useStyles = makeStyles((theme) => ({
  form: {
    width: "70%",
    marginTop: theme.spacing(3),
  },
  input: {
    "&:-webkit-autofill": {
      WebkitTextFillColor: "#fff !important",
    },
  },
  textField: {
    "& .MuiInputLabel-root": {
      color: "white",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "white",
    },
    "& .MuiOutlinedInput-root": {
      color: "white",
      "& fieldset": {
        borderColor: "white", // Default border color
      },
      "&:hover fieldset": {
        borderColor: "white", // Border color on hover
      },
      "&.Mui-focused fieldset": {
        borderColor: "white", // Border color when focused
      },
    },
  },
}));

function LoginAuthentication(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const rememberMe = false;
  const open = true;

  const { setCompanySettings } = useContext(GlobalDataContext);

  const [payload, setPayload] = useState({
    code: "",
    email: props.location.state?.data?.email,
    rememberMe: rememberMe,
  });

  const [error, setError] = useState({
    code: false,
  });

  const setRememberMeCookie = (data) => {
    setCookieFunction("loginSecurityKey", data.loginSecretKey, 30);
  };

  const setCookieFunction = (name, value, days) => {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires;
  };

  const loadSetting = (companyId) => {
    dispatch(getListSettingsById(companyId))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setCompanySettings(data.data);
          localStorage.setItem("companySettings", JSON.stringify(data.data));
        }
      });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (CommonUtil.isEmpty(payload.code)) {
      setError({ ...error, code: true });
      Toast(t("ENTER_OTP"), "error");
      return;
    }

    dispatch(validateAuthenticationCode(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4046") {
          Toast(data.message, "success");
          if (data.data?.loginAuthentication?.loginSecretKey !== null) {
            setRememberMeCookie(data.data?.loginAuthentication);
          }
          localStorage.removeItem(process.env.REACT_APP_TEMP_TOKEN);
          localStorage.setItem(
            process.env.REACT_APP_ACCESS_TOKEN,
            "Bearer " + data.data.access_token,
          );
          localStorage.setItem(
            process.env.REACT_APP_REFRESH_TOKEN,
            data.data.refresh_token,
          );
          const decoded = jwt_decode(data.data.access_token);
          localStorage.setItem("companyId", decoded.companyId);
          localStorage.setItem("companyName", decoded.companyName);
          localStorage.setItem("companyType", decoded.companyType);
          localStorage.setItem("companyCode", decoded.companyCode);
          loadSetting(decoded.companyId);
          decoded.companyType !== "NONE"
            ? decoded.companyType === "PARTNER"
              ? history.push(REACT_DASHBOARD_PANEL)
              : history.push(REACT_URL_DASHBOARD)
            : history.push(REACT_DASHBOARD_PANEL);
        } else Toast(data.message, "error");
      })
      .catch((er) => {});
  };

  const handleChange = (event) => {
    const value = event.target.value;
    const name = event.target.name;

    setPayload({
      ...payload,
      [name]: value,
    });
    setError({
      [name]: false,
    });
  };

  const handleResendOTP = () => {
    const authenticationDTO = {
      email: props.location.state?.data?.email,
      userId: props.location.state?.data?.userId,
      companyId: props.location.state?.data?.companyId,
    };
    dispatch(generateAuthenticationOTPResend(authenticationDTO))
      .unwrap()
      .then((res) => {
        if (res.code === "MSGS4044") {
          Toast(res.message, "success");
          return;
        } else {
          Toast(res.message, "error");
          return;
        }
      });
  };

  const handleRememberMe = () => {
    setPayload({
      ...payload,
      rememberMe: !rememberMe,
    });
  };

  const handleContextMenu = (event) => {
    event.preventDefault();
  };

  const handleOnPasteEvent = (event) => {
    event.preventDefault();
  };

  const handleOnCopyEvent = (event) => {
    event.preventDefault();
  };

  const handleOnCutEvent = (event) => {
    event.preventDefault();
  };

  function onhandleBckButton(e) {
    e.preventDefault();
    history.goBack();
  }

  return (
    <>
      <LoginLayoutV2
        lang={true}
        backbutton={true}
        handleClick={onhandleBckButton}
      >
        <Grid className="center_div">
          <form
            className={classes.form}
            noValidate
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            <Grid item xs={12}>
              <Typography
                variant="h2"
                align="left"
                style={{
                  color:
                    process.env.REACT_APP_ENVIRONMENT === "USA"
                      ? "#fff"
                      : "#464646",
                  fontWeight: "500",
                  marginTop: "180px",
                  opacity: "0.9",
                }}
              >
                {t("EMAIL_VERIFICATION")}
              </Typography>
              <Typography
                variant="subtitle2"
                align="left"
                style={{
                  color:
                    process.env.REACT_APP_ENVIRONMENT === "USA"
                      ? "#fff"
                      : "#7a7b97",
                  marginBottom: "20px",
                  marginTop: "6px",
                  fontSize: "12px",
                  opacity: "0.8",
                }}
              >
                {t("DIGIT_INFO_TEXT")}
              </Typography>
            </Grid>
            <Grid container>
              {/* <Grid item xs style={{ display: 'flex' , width:"100%" }}> */}
              <TextField
                className={classes.textField}
                type={"text"}
                error={error.code}
                name="code"
                label={t("ENTER_CODE") + " *"}
                value={payload.code}
                onChange={(e) => handleChange(e)}
                helperText={error.code}
                validation="numeric"
                inputProps={{ maxLength: 6 }}
                onContextMenu={(e) => handleContextMenu(e)}
                onPaste={(e) => handleOnPasteEvent(e)}
                onCopy={(e) => handleOnCopyEvent(e)}
                onCut={(e) => handleOnCutEvent(e)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end">
                        <img src={keyIcon} alt="loginAuthenticate" />
                      </IconButton>
                    </InputAdornment>
                  ),
                  maxLength: 25,
                }}
                style={{
                  width: "100%",
                }}
              />
              {/* </Grid> */}
            </Grid>
            <Grid container style={{ color: "white" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    sx={{
                      color: "#F2824C",
                      "&.Mui-checked": {
                        color: "#F2824C",
                      },
                    }}
                  />
                }
                label={t("REMEMBER_ME")}
                onClick={handleRememberMe}
              />
            </Grid>
            <Grid container>
              <Grid item xs>
                <Button type="submit" fullWidth variant="contained">
                  {process.env.REACT_APP_ENVIRONMENT === "USA"
                    ? t("VERIFY")
                    : t("COMMON038")}
                </Button>
              </Grid>
            </Grid>
          </form>
          <Grid item xs>
            <Typography
              variant="h5"
              align="center"
              style={{
                color: "#fff",
                marginTop: "40px",
                opacity: "0.9",
              }}
            >
              {t("CODE_NOT_RECEIVE") + " "}
              <Link
                component="button"
                style={{
                  color: "#F2824C",
                  opacity: "0.9",
                }}
                onClick={handleResendOTP}
              >
                {t("RESEND")}
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </LoginLayoutV2>
    </>
  );
}
export default LoginAuthentication;
